import React, { useCallback, useState } from 'react';
import * as Sentry from '@sentry/react';
import { Notification } from '../../components/notifications/Notifications';
import { generatePDF } from '../../utils/generatePDFUtils';
import { DEFAULT_LANGUAGE } from '../../i18n/constants';

const useGeneratePDF = () => {
    const [isDownloadingReport, setDownloadingReport] = useState(false);

    const generatePDFUtils = useCallback(
        async ({
            component,
            filename,
            sendNotifications,
            language = DEFAULT_LANGUAGE,
        }: {
            component: React.ReactNode;
            filename: string;
            sendNotifications: (
                message: string,
                config?: Notification['options'],
            ) => void;
            language?: string;
        }) => {
            setDownloadingReport(true);
            try {
                await generatePDF(component, filename, language);
                sendNotifications('PDF downloaded!', { context: 'success' });
            } catch (error) {
                Sentry.withScope(scope => {
                    scope.setTag('context', 'pdf-generation');
                    scope.setLevel('error');
                    Sentry.captureException(error);
                });
                sendNotifications('PDF download failed!', { context: 'error' });
            } finally {
                setDownloadingReport(false);
            }
        },
        [],
    );

    return {
        isDownloadingReport,
        generatePDFUtils,
    };
};

export default useGeneratePDF;
